export enum Roles {
    USER,
    STUDENT,
    TEACHER,
    ADMIN,
}
